import { jsx as _jsx } from "react/jsx-runtime";
import { withVariants } from './util';
const Tiny = (_jsx("svg", Object.assign({ viewBox: "0 0 8 8" }, { children: _jsx("path", { d: "M2.5 7c-.3 0-.5-.2-.5-.5 0-.1.1-.3.1-.3L4.3 4 2.2 1.9c-.2-.2-.2-.6 0-.8.2-.2.5-.2.7 0l2.5 2.5c.2.2.2.5 0 .7L2.9 6.8c-.1.1-.3.2-.4.2z", fill: "currentColor" }, void 0) }), void 0));
export const variants = {
    tiny: Tiny,
    default: Tiny,
};
export default withVariants(variants);
